import { DependencyRuleNote } from './docDependencies';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertTriangle, Trash2 } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Onaylı belgeyi silme: firma sayfasındaki ile aynı uyarı, onaylanınca belge yeniden yükleme durumuna döner
export const ApprovedDeleteButton = ({ entityType, entityId, docKey, docLabel, onDeleted, testPrefix }) => {
  const [open, setOpen] = useState(false);
  const remove = async () => {
    setOpen(false);
    try {
      const res = await axios.delete(`${API}/${entityType}/${entityId}/document-files/${docKey}`, { params: { approved: true } });
      onDeleted(res.data);
      toast.success('Belge silindi');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Belge silinemedi');
    }
  };
  return (
    <>
      <button type="button" title="Sil" onClick={() => setOpen(true)} className="h-6 w-6 inline-flex items-center justify-center rounded border border-rose-200 text-rose-600 hover:bg-rose-50" data-testid={`${testPrefix}-delete-approved`}>
        <Trash2 className="h-3.5 w-3.5" />
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="approved-delete-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-rose-700"><AlertTriangle className="h-5 w-5" />Onaylı belgeyi siliyorsunuz</AlertDialogTitle>
            <AlertDialogDescription>
              <b>{docLabel}</b>: Onaylı belgeyi siliyorsunuz, bunu yaparsanız tekrar belge yükleyip onaya göndermeniz gerekmektedir, emin misiniz?
              <DependencyRuleNote docKey={docKey} />
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="approved-delete-cancel">Vazgeç</AlertDialogCancel>
            <AlertDialogAction className="bg-rose-600 hover:bg-rose-700" onClick={remove} data-testid="approved-delete-confirm">Evet, Sil</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
